import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

import {GROUNDING_REASON_OPTIONS} from '../constants/groundingReasonOptions';

export const getGroundingReasonDisplayValue = (value: string | Nullish) =>
  value
    ? (GROUNDING_REASON_OPTIONS.find((option) => option.value === value)?.label ?? value)
    : EMPTY_PLACEHOLDER;
